/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML';
import update from 'react-addons-update'; // ES6

var _ = require('lodash');

import ReactTable from "react-table"
import "react-table/react-table.css"

import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.key;

class Authors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",
      md: SectionConfig.md,
      sv: SectionConfig.sv,
      canDeleteApp: false,
      updatetrack: false,
      updateinfobooth: false,
      selectedtrack: {},
      selectedtrackname: '',
      trackname: '',
      infoboothname: '',
      sectionsactive: ["active", "", "", ""],
      trackvalue: '',
      infoboothdes: '',
      selectedinfobooth: {},
      selectedinfoboothname: '',

      authortracks: [],
      authorlist: [],
      speakertrack: "",
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerdes: "",
      columns: [],
      tdata: [],
      updatedspeaker: false,
      selectedspeaker: {}
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.processDataForSaving = this.processDataForSaving.bind(this);
    this.appendSection = this.appendSection.bind(this);
    this.saveAppInfo = this.saveAppInfo.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";
    this.confirmDeleteApp = this.confirmDeleteApp.bind(this);
    this.getAutoIncrementedNumOfApps = this.getAutoIncrementedNumOfApps.bind(this);
    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }

  doDeleteauthor() {
    console.log("Deleted in author");
    var key = this.state.selectedspeaker.key;
    console.log("Update redux state");
    this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: key, subtype: "author", data: undefined })

    console.log("Updating local state");
    this.setState({
      authorlist: this.state.authorlist.filter(el => (el.key === key ? false : true)),
      selectedspeaker: {}
    }, () => {
      console.log(this.state.tdata);
    });
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/author/" + key).set(null);
    this.refs.deleteDialogauthor.hide()

  }
  doDelete() {
    console.log("Do delete ");
    console.log();
    console.log("Item to delete: " + this.state.pathToDelete);
    var found = false;
    this.state.authorlist.map(author => {
      if (author.track == this.state.pathToDelete) {
        found = true;
      }
    })
    if (found) {
      console.log("Author already exists");
      alert("Track Associated with author. Please update authors.")
    } else {
      console.log("Do delete");
      var nodes = removeNodeAtPath({
        treeData: this.state.authortracks,
        path: this.state.pathToDelete,
        getNodeKey: ({ node }) => node.key,
      })
      // this.setState({
      //   authortracks:nodes
      // })

      this.setState({
        authortracks: nodes
      }, () => {
        var tosavelist = {};
        nodes.map((d, i) => {
          tosavelist[d.key] = { name: d.title, o: i }
        })
        console.log(tosavelist);
        firebase.app.database().ref('myapps/' + this.props.params.sub + "/authors/tracks").set(tosavelist);
        this.props.updateobjectdatabytype({ eventkey: this.props.params.sub, type: 'authors', key: "tracks", data: tosavelist });
      });

      // var key = this.state.pathToDelete[0];
      // console.log("Update redux state");
      // this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: key, subtype: "tracks", data: undefined })
      // var newlist = this.state.authortracks.filter(el => {
      //   console.log(el.key);
      //   if (el.key === key) {
      //     return false
      //   } else {
      //     return true;
      //   }
      // });
      // console.log(newlist);
      // this.setState({
      //   authortracks: newlist,
      //   pathToDelete: ""
      // }, () => {
      //   console.log(this.state.authortracks);
      // });
      // firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/tracks/" + key).set(null);

    }
    this.refs.deleteDialog.hide()
  }


  cancelDelete = () => {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  cancelDeleteauthor = () => {
    console.log("Cancel Delete");
    this.setState({
      selectedspeaker: {}
    })
    this.refs.deleteDialogauthor.hide()
  }
  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }


  appendSection(sectionName, icon, treeData) {
    // console.log("In addnew section");
    if (components != null) {
      var selectedSection = null;
      console.log("check here3");
      console.log(components);
      var componenetsdata = components.navigation.menus;
      for (let index = 0; index < componenetsdata.length; index++) {
        const element = componenetsdata[index];
        if (element.name.toLowerCase() == sectionName.toLowerCase()) {
          selectedSection = element;
        }
      }

      if (selectedSection != null) {
        //alert(selectedSection);
        var treeData = treeData;
        var slug = this.getSlug();



        //Convert to json 
        var jsRepr = JSON.stringify(selectedSection);
        //console.log(jsRepr);
        var find = 'data_point\":\"';
        var re = new RegExp(find, 'g');
        jsRepr = jsRepr.replace(re, 'data_point\":\"' + slug + '_');
        selectedSection = JSON.parse(jsRepr);
        // console.log(jsRepr);

        // console.log(treeData);
        // console.log(selectedSection);
        treeData.push(selectedSection);
        this.props.addnewsection(treeData, this.props.params.sub);

        //console.log(treeData);
        this.saveNewMenuStructure(treeData);
        window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new component <b>" + sectionName + "</b> has been added. Check it in the sections panel.", icon);
      } else {
        window.getReactInterfaceToJS().showNotification('bottom', 'right', 'warning', "We couldn't find the required component <b>" + sectionName + "</b>. Make sure you have updated the demo data in firebase.", icon);
      }
    } else {
      window.getReactInterfaceToJS().showNotification('bottom', 'right', 'danger', "Components not fetched. Pls check install manual.", icon);
    }
  }

  saveNewMenuStructure(menus) {
    firebase.app.database().ref(Config.appEditPath + '/navigation/menus').set(menus);
  }

  saveAppInfo(key, value) {
    var update = {};
    update[key] = value;
    this.setState(update);
    firebase.app.database().ref(Config.appEditPath + '/' + key).set(value);
    firebase.app.database().ref(Config.appEditPath + '/appIsSubmited').set(null);
  }


  /**
   * Saving extra sync app info
   * @param {String} value 
   * @param {String} type  shopify | wordpress
   * @param {int} rabid the id of the app
   */
  saveSyncAppInfo(value, type, rabid) {
    var objectToSave = {};
    var path = "saasraab/"
    var slug = this.getSlug();
    if (type == "shopify") {
      path += "shopifySites";
      objectToSave.firestoreCollectionForCategories = slug + "_product_collection_shopify"
      objectToSave.firestoreCollectionForProduct = slug + "_products_shopify";
      objectToSave.shopifySite = value;
    } else if (type == "wordpress") {
      path += "wordpressSites";
      objectToSave.wordpressSite = value;
    }
    path += "/" + rabid;
    firebase.app.database().ref(path).set(objectToSave);
  }

  getObjectDiff(obj1, obj2) {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key);
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key);
        result.splice(resultKeyIndex, 1);
      }
      return result;
    }, Object.keys(obj2));

    return diff;
  }
  processDataForSaving(data) {
    this.setState({
      authortracks: data
    }, () => {
      var tosavelist = {};
      data.map((d, i) => {
        tosavelist[d.key] = { name: d.title, o: i }
      })
      console.log(tosavelist);
      firebase.app.database().ref('myapps/' + this.props.params.sub + "/authors/tracks").set(tosavelist);
      this.props.updateobjectdatabytype({ eventkey: this.props.params.sub, type: 'authors', key: "tracks", data: tosavelist });
    });
  }

  createButton(item, theClass, treeData) {
    return <button onClick={() => {
      this.appendSection(item.componentName, item.icon, treeData);
    }} className={"btn " + theClass}><i className="material-icons">{item.icon}</i>{item.name}</button>
  }

  generateIndex(index) {
    var expandedCount = 0;
    this.state.treeData.forEach(element => {
      if (element.expanded && element.subMenus && element.subMenus.length > 0) {
        expandedCount++;
      }
    });
    return expandedCount;
  }

  formIt(path) {
    if ((path + "").indexOf(',') == -1) {
      return path;
    } else {
      return (path + "").substring((path + "").indexOf(',') + 1);
    }
  }



  refreshDataAndHideNotification(time = 3000) {
    //Hide notifications
    setTimeout(function () { this.setState({ notifications: [] }) }.bind(this), time);
  }


  sectionTabContent() {
    return (
      <div style={{ height: 400 }}>

        <SortableTree
          ref="sortableTree"
          maxDepth={0}
          // isVirtualized={false}
          treeData={this.state.authortracks}
          canNodeHaveChildren={(item) => {
            return false
          }}
          // onChange={treeData => this.setState({ treeData })}
          onChange={data => this.processDataForSaving(data)}
          getNodeKey={getNodeKey}
          generateNodeProps={({ node, path }) => ({
            buttons: [
              <button className="btn-primary" onClick={() => {
                console.log("Clicked");
                console.log(node);
                console.log(path);
                console.log("For tracks");
                console.log(node.title);
                this.setState({
                  sectionsactive: ["", "active", "", ""],
                  trackname: node.title,
                  updatetrack: true,
                  selectedtrackname: node.title,
                  selectedtrack: node
                })
              }}>
                <i className="material-icons">edit</i>
              </button>,
              <div>
                &nbsp;&nbsp;
                <a onClick={() => {
                  this.refs.deleteDialog.show();
                  console.log("Delete");
                  this.setState({ nodeToDelete: node, pathToDelete: path })
                }} >
                  <button className="btn-danger">
                    <i className="material-icons">delete</i>
                  </button></a>
              </div>,
            ],
          })}


        />
      </div>)
  }


  addNewSectionContent(treeData) {
    // console.log("in add new section");
    // console.log(treeData);
    return (<div>

      {/* <button onClick={()=>{this.setState({showAddButton:!this.state.showAddButton})}} className="btn btn-rose"><i className={!this.state.showAddButton?"fa fa-window-restore":"fa fa-minus"}></i> {!this.state.showAddButton?"Add Master detail":"Cancel adding Master detail"}</button> */}
      <ConditionalDisplay condition={true} >
        <div>

          <hr />
          {T.td("MASTER DETAILS VIEWS")}
          <br />
          {this.state.md.map((item) => {
            return this.createButton(item, Config.designSettings.submitButtonClass, treeData);
          })}
          <hr />

        </div>
      </ConditionalDisplay>
      <div>

        <hr />
        {T.td("SPECIFIC VIEWS")}
        <br />

        {this.state.sv.map((item) => {
          return this.createButton(item, Config.designSettings.buttonSuccessClass, treeData);
        })}
        <hr />
        <br />
      </div>
    </div>)
  }

  confirmDeleteApp() {
    if (this.state.inputDelete.length > 0 && this.state.inputDelete === "delete") {
      firebase.app.database().ref(Config.appEditPath).remove();
      this.getAutoIncrementedNumOfApps();
      window.location = "#"
    } else alert(T.ts("Please write delete to confirm deleting the app"))
  }

  // checkIfCanDeleteApp(rabId) {
  //   var _this = this;
  //   var rab_pointers = firebase.app.database().ref("rab_pointers/apps_queue/" + rabId + "_both");
  //   rab_pointers.on('value', function (snapshot) {
  //     _this.setState({
  //       canDeleteApp: snapshot.val() ? false : true
  //     })
  //   });
  // }

  getAutoIncrementedNumOfApps() {
    var num_of_apps_ai = firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid + '/numOfApps');
    num_of_apps_ai.transaction(function (ai) {
      if (ai) {
        ai--;
      }
      return ai;
    }, function (e, done, ai) {
      firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid).update({
        numOfApps: ai.val()
      });
    });
  }
  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      trackname: "",
      selectedtrack: {},
      selectedtrackname: '',
      updatetrack: false,
      updateinfobooth: false,
      selectedinfobooth: {},
      selectedinfoboothname: "",
      trackvalue: '',
      infoboothname: '',
      infoboothdes: '',
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakertrack: "",
      speakerdes: "",
      speakerimage: "./assets/img/profile.jpg"
    })
  }


  basicInfoContent() {

    return (
      <div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Track name")}</label>
            <input value={this.state.trackname} name="name" onChange={(event) => {
              this.setState({ trackname: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" onClick={() => {
            if (this.state.updatetrack) {
              console.log("Updating Track");

              console.log(this.state.trackname);
              console.log(this.state.selectedtrack);
              var nameoftrack = this.state.trackname;
              var keyoftrack = this.state.selectedtrack.key;
              var order = this.state.selectedtrack.o
              this.setState((prevState) => {
                return {
                  authortracks: prevState.authortracks.map(
                    (content, i) => content.key === keyoftrack ? { ...content, title: this.state.trackname }
                      : content
                  ),
                  trackname: "",
                  updatetrack: false,
                  selectedtrackname: '',
                  selectedtrack: {},
                  sectionsactive: ["active", "", "", ""]
                }
              }, () => {
                firebase.app.database().ref("myapps/" + this.props.params.sub + "/authors/tracks/" + keyoftrack + "/name").set(nameoftrack).then(() => {
                  console.log("Updated");
                }).catch(err => {
                  console.log(err);
                })
                this.updatetableaftertrackupdate();
                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: keyoftrack, subtype: "tracks", data: { o: order, name: nameoftrack } })

                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The track <b>" + nameoftrack + "</b> has been updated.");

              });

            } else {
              console.log("Adding new track");
              console.log(this.state.trackname);
              var firebaseref = firebase.app.database().ref('myapps/' + this.props.params.sub + "/authors/tracks").push();
              var keyoftrack = firebaseref.key;
              console.log(keyoftrack);
              // var  = this.state.treeData;
              var o = this.state.authortracks.length;
              var toupdatedata = {
                name: this.state.trackname,
                o: o
              }
              firebaseref.set(toupdatedata)
              var nameoftrack = this.state.trackname;
              this.setState((prevState) => {
                return {
                  authortracks: [...prevState.authortracks, {
                    key: keyoftrack,
                    title: this.state.trackname,
                    expanded: true
                  }],
                  trackname: ""
                }
              }, () => {
                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: keyoftrack, subtype: "tracks", data: toupdatedata })
                // this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: 'authors', key: keyoftrack, data: toupdatedata })
                // this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'infobooths', data: this.processdataforfirebase(this.state.treeData) });
                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new track <b>" + nameoftrack + "</b> has been added. Check it in the tracks panel.");
              });
            }
          }} className="btn btn-primary" disabled={this.state.updatetrack ? (this.state.trackname == this.state.selectedtrackname) : !this.state.trackname}>{T.td(this.state.updatetrack ? "Update Track" : "Add Track")}</button>
        </div>

      </div>)
  }

  componentWillMount() {
    var authordata = {};
    var authortracks = [];
    var authorlist = [];
    var columns = [
      {
        Header: 'Name',
        accessor: (row) => {
          if (row.name) {
            return row.name
          } else {
            return ""
          }
        },
        id: "name",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Post',
        // accessor: 'post',
        accessor: (row) => {
          if (row.post) {
            return row.post
          } else {
            return ""
          }
        },
        id: "post",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Company',
        accessor: (row) => {
          if (row.company) {
            return row.company
          } else {
            return ""
          }
        },
        id: "company",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      }, {
        Header: 'TrackName',
        accessor: (row) => {
          if (row.trackname) {
            return row.trackname
          } else {
            return ""
          }
        },
        id: "trackname",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Photo',
        accessor: (row) => {
          if (row.pic) {
            return row.pic
          } else {
            return ""
          }
        },
        id: "pic",
        maxWidth: 150,
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        Cell: ({ value }) => {
          if (value != "") {
            return <img src={value} className="roundedimage" />

          } else {
            return <img src="./assets/img/profile.jpg" className="roundedimage" />

          }
        },
      },
      {
        Header: 'Description',
        accessor: (row) => {
          if (row.des) {
            return row.des
          } else {
            return ""
          }
        },
        id: "des",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        Cell: ({ value }) => {
          return <div dangerouslySetInnerHTML={{ __html: value }} />
        },
      },
      {
        Header: 'Action',
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 100,
        Cell: row => {
          return (
            <div>
              <button className="btn-primary" onClick={() => {
                console.log(row.original);
                console.log("Edit clicked");
                this.setState({
                  updatedspeaker: true,
                  selectedspeaker: row.original,
                  speakertrack: row.original.track ? row.original.track : "",
                  speakername: row.original.name,
                  speakerpost: row.original.post ? row.original.post : "",
                  speakercompany: row.original.company ? row.original.company : "",
                  speakerimage: row.original.pic ? row.original.pic : "./assets/img/profile.jpg",
                  speakerdes: row.original.des ? row.original.des : "",
                  sectionsactive: ["", "", "", "active"],
                })
              }
              }> <i className="material-icons">edit</i></button>
              <br /> <br />
              <button className="btn-danger" onClick={() => {
                console.log(row.original);
                console.log("Delte clicked");
                this.refs.deleteDialogauthor.show();
                this.setState({
                  selectedspeaker: row.original
                })
              }
              }> <i className="material-icons">delete</i></button>
            </div>)
        },
      },
    ];

    if (this.props.events[this.props.params.sub]) {
      if (this.props.events[this.props.params.sub].authors) {
        authordata = JSON.parse(JSON.stringify(this.props.events[this.props.params.sub].authors));
        console.log(authordata);
        var tracks = authordata.tracks;
        var authors = authordata.author ? authordata.author : {};
        Object.keys(authors).map((author) => {
          var d = authors[author];
          d["key"] = author;
          d["trackname"] = tracks[d.track].name
          authorlist.push(d);
        });
        Object.keys(tracks).map(track => {
          var mdata = tracks[track];
          var data = {};
          data["key"] = track;
          data["o"] = mdata.o;

          data["expanded"] = true;
          data["title"] = mdata.name;
          authortracks.push(data);
        });
        authortracks = _.sortBy(authortracks, "o");
      }
    }
    this.setState({
      authorlist: authorlist,
      authortracks: authortracks,
      columns: columns
    });
    // console.log(JSON.stringify(categories));

  }
  updatetableaftertrackupdate = () => {
    console.log(this.state.authortracks);
    var trackdata = _.keyBy(this.state.authortracks, 'key');
    console.log(trackdata);
    var newlist = [];
    this.state.authorlist.map(auth => {
      if (trackdata[auth.track]) {
        auth.trackname = trackdata[auth.track].title;
      } else {
        auth.trackname = "";
      }
      newlist.push(auth);
    })
    console.log(newlist);
    this.setState({
      authorlist: newlist
    })
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  authortable() {
    return (
      <div style={{ padding: '50px' }}>
        <ReactTable
          data={this.state.authorlist}
          columns={this.state.columns}
          sortable={true}
          multiSort={true}
          filterable={true}
          showPagination={false}
          defaultSorted={[
            {
              id: "name",
              desc: false
            }
          ]}
          defaultFilterMethod={(filter, row) => { return row[filter.id].toLowerCase().includes(filter.value.toLowerCase()) }}
        />
      </div>

    )
  }
  gotomainlist() {
    this.setState({
      sectionsactive: ["", "", "active", ""],
      selectedspeaker: {},
      speakername: "",
      speakerpost: "",
      speakerimage: "./assets/img/profile.jpg",
      speakercompany: "",
      speakerdes: "",
      speakertrack: ""
    })
  }
  doedit(d) {
    console.log("in edit");
    var key = this.state.selectedspeaker.key;
    console.log(d);
    console.log("Update redux state");
    if (d.company == "") {
      delete d.company;
    }
    if (d.post == "") {
      delete d.post;
    }
    if (d.des == "") {
      delete d.des;
    }
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/author/" + key).update(d);
    this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: key, subtype: "author", data: d })
    var trackdata = _.keyBy(this.state.authortracks, 'key');
    console.log(trackdata);
    console.log(trackdata[this.state.speakertrack].title);
    d["trackname"] = trackdata[this.state.speakertrack].title;
    // this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: d })
    console.log("Updating local state");
    this.setState({
      authorlist: this.state.authorlist.map(el => (el.key === key ? { ...el, ...d } : el))
    }, () => {
      console.log(this.state.tdata);
    });
    console.log("Saving to firebase");

    console.log(d);

    this.gotomainlist();

  }
  addspeaker() {
    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <div className="form-group">
          <label>{T.td("Speaker Image")}</label>
          <Image
            path={this.props.params.sub + "/authors/"}

            parentKey="icon"
            options={{}}
            updateAction={(key, value) => {
              console.log(value);
              this.setState({
                speakerimage: value
              })
              // this.saveAppInfo("applist/" + this.props.params.sub + "/ai", value);
            }}
            class="roundedimage"
            theKey="icon"
            value={this.state.speakerimage} />
        </div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Speaker name")}</label>
            <input value={this.state.speakername} name="name" onChange={(event) => {
              this.setState({
                speakername: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Track Name")}</label>
            <select className="form-control" value={this.state.speakertrack} onChange={(event) => {
              this.setState({ speakertrack: event.target.value });
            }}>
              <option disabled hidden value=''></option>

              {this.state.authortracks.map(track => {
                return (
                  <option key={track.key} value={track.key}>{track.title}</option>
                )
              })}
            </select>
          </div>
        </div>
        <br />


        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">class</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Post")}
            </label>
            <input value={this.state.speakerpost} name="name" onChange={(event) => {
              this.setState({
                speakerpost: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">supervised_user_circle</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Company")}
            </label>
            <input value={this.state.speakercompany} name="name" onChange={(event) => {
              this.setState({
                speakercompany: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
        </div>
        <div className="input-group">

        </div>
        <br />


        <br />
        <div className="form-group">
          <label>{T.td("Speaker Description")}</label>
          <HTML theKey={"htmlkey"} value={this.state.speakerdes} updateAction={(data) => {
            this.setState({
              speakerdes: data
            })
          }}></HTML>

        </div>


        {/*<button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalCookie1">{T.td("Delete App")}</button>*/}
        <br /><br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" className="btn btn-primary"
            onClick={() => {
              console.log(this.state.speakername);
              console.log(this.state.speakerpost);
              console.log(this.state.speakercompany);
              console.log(this.state.speakerimage);
              console.log(this.state.speakerdes);
              console.log("Saving to database and redux");
              console.log(this.state.selectedspeaker);
              var d = {};
              d.name = this.state.speakername;
              d.post = this.state.speakerpost;
              d.track = this.state.speakertrack;
              d.company = this.state.speakercompany;
              if (this.state.speakerimage != "./assets/img/profile.jpg") {
                d.pic = this.state.speakerimage;
              }
              d.des = this.state.speakerdes;
              if (this.state.updatedspeaker) {
                console.log("Updating speaker");
                console.log(d);
                this.doedit(d);
              } else {
                console.log("add speaker");
                console.log(d);
                if (d.company == "") {
                  delete d.company;
                }
                if (d.post == "") {
                  delete d.post;
                }
                if (d.des == "") {
                  delete d.des;
                }
                var speakercreate = firebase.app.database().ref("myapps/" + this.props.params.sub + "/" + this.props.route.type + "/author").push();
                var speakerkey = speakercreate.key;
                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: speakerkey, subtype: "author", data: d })
                speakercreate.set(d)
                d["key"] = speakerkey;
                var trackdata = _.keyBy(this.state.authortracks, 'key');
                console.log(trackdata);
                console.log(trackdata[this.state.speakertrack].title);
                d["trackname"] = trackdata[this.state.speakertrack].title;
                this.setState({
                  authorlist: [...this.state.authorlist, d]
                });

                this.gotomainlist();
              }
            }
            }
            disabled={this.state.updatedspeaker ? ((this.state.speakertrack == this.state.selectedspeaker.track) && (this.state.speakername == this.state.selectedspeaker.name) && (this.state.speakerpost == this.state.selectedspeaker.post) && (this.state.speakercompany == this.state.selectedspeaker.company) && (this.state.speakerimage == this.state.selectedspeaker.pic) && (this.state.speakerdes == this.state.selectedspeaker.des) || !(this.state.speakername && this.state.speakertrack)) : !(this.state.speakername && this.state.speakertrack)}>
            {T.td(this.state.updatedspeaker ? "Update " + this.props.route.name : "Add " + this.props.route.name)}
          </button>
        </div>

      </div>)
  }
  render() {
    var tracktitle = this.state.updatetrack ? "Update Track" : "Add new Track";

    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td("Tracks"),
        active: this.state.sectionsactive[0],
        label1: T.ts("Drag n Drop them Also you can nest them"),
        label2: T.td("Track sections"),
        content: this.sectionTabContent()
      },
      {
        name: "sectionsadd",
        icon: "playlist_add",
        title: T.td("Add Track"),
        active: this.state.sectionsactive[1],
        label1: T.ts(tracktitle),
        content: this.basicInfoContent()
      },
      {
        name: "authorlist",
        icon: "subject",
        title: T.td(this.capitalize(this.props.route.type)),
        active: this.state.sectionsactive[0],
        label1: T.ts(this.capitalize(this.props.route.type) + " List"),
        content: this.authortable()
      }, {
        name: "images",
        icon: "collections",
        title: T.td("Add " + this.props.route.name),
        active: this.state.sectionsactive[1],
        label1: T.td("Add " + this.props.route.name),
        content: this.addspeaker()
      }
    ];

    return (
      <div>
        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Section name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.nodeToDelete.title}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>
        <SkyLight hideOnOverlayClicked ref="deleteDialogauthor" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Section name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.selectedspeaker.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.cancelDeleteauthor()} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDeleteauthor()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>


          <Wizzard
            title={"Authors"}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />
        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updateobjectwithtracks: dispatch.eventmodel.updateobjectwithtracks,
  updatedataobjectbytypeandsubtype: dispatch.eventmodel.updatedataobjectbytypeandsubtype,
  updateobjectdatabytype: dispatch.eventmodel.updateobjectdatabytype
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Authors);


// WEBPACK FOOTER //
// ./src/containers/Builder/authors.js